import { useQuery } from '@tanstack/vue-query'

import { getPropertyOwnerBankAccountStatusCounts } from '../propertyOwnersEndpoints'
import { ownersQueryKeys } from '../propertyOwnersQueryKeys'

// PO bank-verification queue counts. Subscribes to the same key the review
// mutations invalidate, so the sidebar badge stays fresh without an extra
// fetch. Mirrors the investor bank-verification counts query.
export function usePropertyOwnerBankAccountStatusCountsQuery() {
  return useQuery({
    queryKey: ownersQueryKeys.bankAccountStatusCounts(),
    queryFn: getPropertyOwnerBankAccountStatusCounts,
  })
}
